// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__zT3Db","itemTitle":"ClientEmergencyInfo_itemTitle__1LBmq","itemText":"ClientEmergencyInfo_itemText__3jYcx"};